import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "monthname",
})
export class MonthNamePipe implements PipeTransform {
  transform(value: number, len?: number): string {
    const names = [
      "Januari",
      "Februari",
      "Maart",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Augustus",
      "September",
      "Oktober",
      "November",
      "December",
    ];
    if (value < 0 || value > 11) {
      return "🤔";
    }
    const rv = names[value];
    return len ? rv.substring(0, len) : rv;
  }
}
